import React from 'react';
import { AI_FEATURES } from '@/constants/content';
import { Inbox, Search, ScanText } from 'lucide-react';

const iconMap = {
  Inbox: Inbox,
  Search: Search,
  ScanText: ScanText,
};

export const AIPower = () => {
  return (
    <section
      id="soluciones"
      className="py-20 lg:py-32 bg-white"
      data-testid="ai-power-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2
            className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: 'Manrope, sans-serif' }}
            data-testid="ai-section-title"
          >
            {AI_FEATURES.title}
          </h2>
          <p className="text-lg text-gray-600" data-testid="ai-section-subtitle">
            {AI_FEATURES.subtitle}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12" data-testid="ai-features-grid">
          {AI_FEATURES.features.map((feature) => {
            const Icon = iconMap[feature.icon];
            return (
              <article
                key={feature.id}
                className="group relative bg-gray-50 rounded-2xl p-8 hover:bg-white hover:shadow-xl transition-all duration-300 border border-gray-200"
                style={{ '--hover-border-color': '#D7A22F' }}
                onMouseEnter={(e) => e.currentTarget.style.borderColor = '#D7A22F'}
                onMouseLeave={(e) => e.currentTarget.style.borderColor = '#E5E7EB'}
                data-testid={`ai-feature-${feature.id}`}
              >
                {/* Icon */}
                <div className="mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-700 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                </div>

                {/* Content */}
                <h3
                  className="text-xl font-bold text-gray-900 mb-3"
                  style={{ fontFamily: 'Manrope, sans-serif' }}
                  data-testid={`ai-feature-title-${feature.id}`}
                >
                  {feature.title}
                </h3>
                <p
                  className="text-gray-600 leading-relaxed"
                  data-testid={`ai-feature-description-${feature.id}`}
                >
                  {feature.description}
                </p>

                {/* Hover Accent */}
                <div className="absolute top-0 left-0 w-1 h-full rounded-l-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{ background: 'linear-gradient(to bottom, #D7A22F, #C4911F)' }}></div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
